// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import Vuetify from 'vuetify';

Vue.config.productionTip = false;

// Bootstrap //
import './assets/bootstrap-lcp/css/bootstrap.css';
import './assets/bootstrap-lcp/js/tooltip.js';
import './assets/bootstrap-lcp/js/popover.js';

// Vuetify //
Vue.use(Vuetify);
import 'vuetify/dist/vuetify.min.css';

// Material Icons //
import './assets/material-icons-lcp.css';

// Font Awesome Icons //
import Icon from 'vue-awesome/components/Icon';
Vue.component('icon', Icon);
import 'vue-awesome/icons';

/* eslint-disable no-new */
window.vm = new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
});




// WEBPACK FOOTER //
// ./src/main.js